import AttributeImagesList from '../../views/talent/AttributeImagesList.vue';
import SampleImageModal from '../../components/SampleImageModal.vue';

// 属性画像一覧
window.Vue.component('talent-attribute-images-list', AttributeImagesList);
window.Vue.component('sample-image-modal', SampleImageModal);
